import React from "react";
import { formatNumber } from "../utils/helper";

const VideoCard = ({ info }) => {
  const { snippet, statistics } = info;
  const { channelTitle, title, thumbnails } = snippet;

  return (
    <div className="md:p-2 md:m-2 md:w-72 w-full p-[4%]  shadow-lg">
      <img className="rounded-lg w-screen" alt="thumbnail" src={thumbnails.medium.url} />
      <ul>
        <li className="font-bold text-black-500 py-2">{title}</li>
        <li className="font-bold text-gray-500 py-2">{channelTitle}</li>
        { (statistics?.viewCount) ? <li className="font-bold text-blue-500 py-2">{formatNumber(statistics?.viewCount)} views</li> : null}
      </ul>
    </div>
  );
};

export const AdVideoCard = ({ info }) => {
  return (
    <div className="md:p-1 md:m-1 p-1 m-1 border border-orange-500">
      <p className="font-bold text-xl text-red-500">Ad</p>
      <VideoCard info={info} />
    </div>
  );
};

export default VideoCard;
